import { render, staticRenderFns } from "./templateOne.vue?vue&type=template&id=4276f1e3&scoped=true"
import script from "./templateOne.vue?vue&type=script&lang=js"
export * from "./templateOne.vue?vue&type=script&lang=js"
import style0 from "./templateOne.vue?vue&type=style&index=0&id=4276f1e3&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276f1e3",
  null
  
)

export default component.exports